import { Fade, Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { RoomTypeBrief } from '../../types/roomtype'
import RoomtypeRowMobile from './RoomtypeRowMobile'
import UserRowMobileSkeleton from './RoomtypeRowMobile.skeleton'
import useStyles from './styles/RoomtypesTable.styles'

interface RoomtypesTableMobileProps {
  loading: boolean
  data: RoomTypeBrief[]
  hasAccessToViewRoomTypeTabs: boolean | undefined
}

export const RoomtypesTableMobile: React.FC<RoomtypesTableMobileProps> = ({
  loading,
  data,
  hasAccessToViewRoomTypeTabs
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHeadMobile}>
        <div className={classes.tableHeadCellMobile}>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
      </div>
      {loading
        ? Array(7)
            .fill(null)
            .map((item, index) => (
              <UserRowMobileSkeleton
                key={`user-row-mobile-skeleton${index.toString()}`}
              />
            ))
        : data?.map((singleRoomType, index) => (
            <Fade in timeout={600} key={index}>
              <div>
                <RoomtypeRowMobile
                  hasAccessToViewRoomTypeTabs={hasAccessToViewRoomTypeTabs}
                  data={singleRoomType}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
